import {Switch, Route, HashRouter} from 'react-router-dom'
// import Savings from "../pages/savings";
// import SavingsAlt from "../pages/savings-alt";
// import SavingsSummary from "../pages/savings-summary";
import SavingsSimple from "../pages/savings-simple";
import Questions from "../pages/questions";
import P2 from "../pages/p2";
import React from "react";
import styles from './main.module.scss';

function Main() {
    return (
        <main className={styles.main}>
            <HashRouter>
                <Switch>
                    <Route exact path='/' component={Questions}/>
                    {/*<Route exact path='/savings' component={Savings}/>*/}
                    {/*<Route exact path='/savings-alt' component={SavingsAlt}/>*/}
                    {/*<Route exact path='/savings-alt-1' component={SavingsAlt}/>*/}
                    {/*<Route exact path='/savings-alt-2' component={SavingsAlt}/>*/}
                    {/*<Route exact path='/savings-summary' component={SavingsSummary}/>*/}
                    <Route exact path='/savings-simple' component={SavingsSimple}/>
                    <Route exact path='/p2' component={P2}/>
                </Switch>
            </HashRouter>
        </main>
    );
}

export default Main;